<script>
  import VulcanSalute from '../gestures/VulcanSalute.svelte'
  const states = [{ position: { x: 50, y: 50 }, rotation: 0 }]
</script>

<VulcanSalute {states} type="simple" on:end on:event />
